import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b4b5f56c")

_pushScopeId("data-v-b4b5f56c")
const _hoisted_1 = /*#__PURE__*/_createVNode("dig-ui-title", { class: "title-1 center" }, " Vos primes CEE ", -1)
const _hoisted_2 = {
  key: 0,
  class: "loader-container"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("dig-ui-loader", null, null, -1)
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "title-2 center" }
const _hoisted_6 = { class: "title-3" }
const _hoisted_7 = { class: "col-tax-bracket" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_base_card = _resolveComponent("base-card")

  return (_openBlock(), _createBlock(_component_base_card, { class: "main-card" }, {
    default: _withId(() => [
      _hoisted_1,
      ($setup.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_2, [
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
      (!$setup.loading)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ALL_WORKS, (work) => {
              return (_openBlock(), _createBlock(_component_base_card, {
                class: "work-card",
                key: work.type
              }, {
                default: _withId(() => [
                  _createVNode("dig-ui-title", _hoisted_5, _toDisplayString($setup.t(`Simulation.WorksTypes.${work.type}`)), 1),
                  _createVNode("dig-input-text", {
                    id: `cee-name-${work.type}`,
                    value: $setup.getCeeName(work.type),
                    onBlur: ($event: any) => ($setup.updateMultiple('name', work.type, $event.target.value))
                  }, " Organisme ", 40, ["id", "value", "onBlur"]),
                  _createVNode("dig-input-text", {
                    id: `cee-date-${work.type}`,
                    type: "date",
                    value: $setup.getCeeDate(work.type),
                    onBlur: ($event: any) => ($setup.updateMultiple('date', work.type, $event.target.value))
                  }, " Date ", 40, ["id", "value", "onBlur"]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ALL_POWER_TYPES, (power) => {
                    return (_openBlock(), _createBlock("div", { key: power }, [
                      _createVNode("dig-ui-title", _hoisted_6, _toDisplayString($setup.t(`Simulation.PowerType.${power}`)), 1),
                      _createVNode("div", _hoisted_7, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.ALL_TAX_BRACKETS, (taxBracket) => {
                          return (_openBlock(), _createBlock("div", { key: taxBracket }, [
                            _createVNode("dig-input-number", {
                              id: "cee",
                              value: $setup.getCeePrice(work.type, power, taxBracket),
                              onBlur: ($event: any) => (
                  $setup.update(
                    'price',
                    work.type,
                    power,
                    taxBracket,
                    $event.target.value,
                  )
                ),
                              suffix: `€/${$setup.t(`Simulation.WorksUnits.${work.type}`)}`
                            }, _toDisplayString($setup.t(`Simulation.TaxBracket.${taxBracket}`)), 41, ["value", "onBlur", "suffix"])
                          ]))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})